import React from 'react';
import {ShimmerThumbnail} from "react-shimmer-effects";
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

function CardBookShimmer({isLivresPage}) {
    return (
        <div className="container mx-auto flex flex-wrap mt-5">
            {/* Filters Shimmer - Only for Livres Page */}
            {isLivresPage && (
                <div className="w-full md:w-1/4 mb-8 md:mb-2 md:pr-8">
                    <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
                        <div className="space-y-4">
                            {/* Category Title Shimmer */}
                            <div className="bg-gray-200 animate-pulse h-6 w-32 mb-4 rounded"></div>

                            {/* Search Input Shimmer */}
                            <div className="relative">
                                <div className="w-full h-10 bg-gray-200 animate-pulse rounded-xl"></div>
                                <SearchRoundedIcon
                                    className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-300"
                                />
                            </div>

                            {/* Filter Categories Shimmer */}
                            <div className="space-y-2">
                                {[1, 2, 3, 4].map((item) => (
                                    <div
                                        key={item}
                                        className="h-10 bg-gray-200 animate-pulse rounded-lg"
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Books Grid Shimmer */}
            <div className={`w-full ${isLivresPage ? 'md:w-3/4' : 'md:w-full'} flex flex-col`}>
                <div className={`grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3`}>
                    {[1, 2, 3, 4, 5, 6].map((item) => (
                        <div
                            key={item}
                            className="bg-gray-50 rounded-xl overflow-hidden shadow-sm animate-pulse"
                        >
                            {/* Book Cover Shimmer */}
                            <div className="relative h-56 bg-gray-200 flex justify-center items-center">
                                <ShimmerThumbnail
                                    height={224}
                                    width={window.innerWidth < 768 ? 150 : 224} // Largeur adaptable
                                    rounded
                                    className="w-full h-full object-contain"
                                />

                            </div>

                            {/* Book Details Shimmer */}
                            <div className="p-4 space-y-2">
                                <div className="h-5 bg-gray-200 w-24 rounded mb-2"></div>
                                <div className="h-6 bg-gray-200 w-40 rounded mb-1"></div>
                                <div className="h-4 bg-gray-200 w-32 rounded"></div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Pagination Shimmer - Only for Livres Page */}
                {isLivresPage && (
                    <div className="flex justify-center mt-8">
                        <div className="inline-flex rounded-lg shadow-sm">
                            {/* Previous Button Shimmer */}
                            <div className="p-2 bg-gray-200 rounded-l-lg w-10 h-10 animate-pulse"></div>

                            {/* Page Numbers Shimmer */}
                            {[1, 2, 3].map((item) => (
                                <div
                                    key={item}
                                    className="px-4 py-2 bg-gray-200 w-10 h-10 animate-pulse border-r"
                                />
                            ))}

                            {/* Next Button Shimmer */}
                            <div className="p-2 bg-gray-200 rounded-r-lg w-10 h-10 animate-pulse"></div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default CardBookShimmer;